import * as React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Divider from "@mui/material/Divider";
import { translations } from "../translations";

import axios from "axios";
import SubscribeButton from "../components/SubscribeButton";

const SubscriptionPage = ({ siteLanguage }) => {
  axios.defaults.withCredentials = true;

  const navigate = useNavigate();

  const handleSubscription = async (event) => {
    event.preventDefault();

    // Start your Stripe flow here
  };

  const benefits = [
    "Unlimited questions per month with no usage limits",
    "Access to your question history and ChatGPT response history",
    "$20/month",
  ];

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      xs={11}
      sm={8}
      md={6}
      lg={4}
    >
      <Typography align="center" component="h1" variant="h4" gutterBottom>
        Premium Subscription
      </Typography>

      <Grid
        item
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Card
          sx={{
            backgroundColor: "#541b14",
            color: "#fff",
            marginBottom: "20px",
          }}
        >
          <CardContent>
            <Typography
              style={{ marginBottom: "20px" }}
              align="center"
              component="h2"
              variant="h5"
              gutterBottom
            >
              Benefits
            </Typography>

            {benefits.map((benefit, index) => (
              <Box key={index} sx={{ mb: 2 }}>
                <Typography variant="body1">• {benefit}</Typography>
                {index !== benefits.length - 1 && (
                  <Divider sx={{ backgroundColor: "gray", mt: 1 }} />
                )}
              </Box>
            ))}
          </CardContent>
        </Card>
        <SubscribeButton
          style={{
            backgroundColor: "darkgreen",
            color: "#000",
            alignSelf: "center",
            marginTop: "20px",
          }}
        />
      </Grid>
    </Grid>
  );
};

export default SubscriptionPage;
